<template>
  <div class="employee-tasks-list">
    <div class="employee-tasks-list__head">
      <p class="employee-tasks-list__title">
        <span class="employee-tasks-list__title-prepend">
          {{ $t('EMPLOYEES.ITEM') }}:
        </span>
        <span
          v-if="employeeTitle"
          class="employee-tasks-list__title-text flex-grow-1 text-center subtitle-1"
        >
          {{ employeeTitle }}
        </span>
      </p>
      <p class="employee-tasks-list__day-title text-h6 mb-1">
        {{ getDayTitle }}
      </p>
      <p class="employee-tasks-list__week-title subtitle-1">
        {{ getDayWeekTitle }}
      </p>
    </div>
    <div class="employee-tasks-list__body">
      <div class="employee-tasks-list__scroll-area">
        <div class="employee-tasks-list__pane">
          <div class="employee-tasks-list__container">
            <component
              :is="getComponentByType(task.type)"
              v-for="(task, index) in tasks"
              :key="index"
              :task="task"
              class="pa-4 mb-1"
              v-on="$listeners"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import localable from 'vuetify/lib/mixins/localable';
import { EVENT, BLOCK_DAY } from '../common/types';

export default {
  name: 'EmployeeTasksList',

  components: {
    EventTask: () => import('./tasks/EventTask'),
    BlockDayTask: () => import('./tasks/BlockDayTask')
  },

  mixins: [localable],

  props: {
    employee: {
      type: Object,
      default: () => ({})
    },
    day: {
      type: [String, Array, Object, Date],
      default: () => ({}),
      validator: prop => moment(prop).isValid()
    },
    tasks: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    currentDate() {
      return moment.locale(this.currentLocale) && moment(this.day);
    },
    employeeTitle() {
      const first = this.employee.first_name || '';
      const last = this.employee.last_name || '';

      return `${first} ${last}`.trim();
    },
    getDayTitle() {
      return this.currentDate.format('MMMM DD');
    },
    getDayWeekTitle() {
      return this.currentDate.format('dddd');
    }
  },

  methods: {
    getComponentByType(type) {
      switch (type) {
        case EVENT:
          return 'EventTask';
        case BLOCK_DAY:
          return 'BlockDayTask';

        default:
          throw new Error('Undefined task type!');
      }
    }
  }
};
</script>

<style lang="scss">
.employee-tasks-list {
  width: 100%;
  max-height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;

  & &__head {
    flex: 1;
  }

  & &__body {
    display: flex;
    flex: 1 1 60%;
    overflow: hidden;
    position: relative;
    flex-direction: column;
  }

  & &__scroll-area {
    display: flex;
    flex: 1 1 auto;
    overflow-y: auto;
    align-items: flex-start;
  }

  & &__pane {
    width: 100%;
    flex: none;
    display: flex;
    overflow-y: hidden;
    align-items: flex-start;
  }

  & &__container {
    width: 100%;
    height: 100%;
  }

  & &__title {
    display: flex;
    align-items: baseline;

    &-prepend {
      margin-right: 4px;
    }

    &-text {
      flex-grow: 1;
      text-align: center;
    }
  }

  & &__day-title,
  & &__week-title {
    text-align: center;
  }
}
</style>
